import { render } from "./Salary.vue?vue&type=template&id=1bd5d7d0&scoped=true&ts=true"
import script from "./Salary.vue?vue&type=script&lang=ts"
export * from "./Salary.vue?vue&type=script&lang=ts"

import "./Salary.vue?vue&type=style&index=0&id=1bd5d7d0&lang=scss&scoped=true"

import exportComponent from "/var/www/html/drupal/modules/custom/nvschade_calculator/assets/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bd5d7d0"]])

export default __exports__